<div class="tabs-bg">
  <div class="tabs">
    <button *ngIf="showShuntingTab" class="tab" [class.active]="selected() === 'pending'" (click)="setSelected('pending')">
      <span class="chip" [class.active]="selected() === 'pending'">
        <span class="label" [class.active]="selected() === 'pending'">Shunting ({{ shuntingCount }})</span>
      </span>
    </button>
    <button class="tab" [class.active]="selected() === 'outgoing'" (click)="setSelected('outgoing')">
      <span class="chip" [class.active]="selected() === 'outgoing'">
        <span class="label" [class.active]="selected() === 'outgoing'">Receiving ({{ receivingCount }})</span>
      </span>
    </button>
    <button class="tab" [class.active]="selected() === 'completed'" (click)="setSelected('completed')">
      <span class="chip" [class.active]="selected() === 'completed'">
        <span class="label" [class.active]="selected() === 'completed'">Completed ({{ completedCount }})</span>
      </span>
    </button>
  </div>
</div>

